/**
 * @author Eric Otto
 */

module.exports = {
    init: function () {
        'use strict';

        const slider = document.getElementById('slider');

        if (!slider) {
            return;
        }

        const lory = require('lory.js').lory,
            items = slider.getElementsByClassName('js_slide'),
            dotCount = items.length,
            dotContainer = slider.querySelector('.js_dots'),
            dotListItem = document.createElement('li');

        for (let i = 0, len = items.length; i < len; i++) {
            let image = window.devicePixelRatio === 2
                ? items[i].getAttribute('data-2x')
                : items[i].getAttribute('data-1x');

            items[i].style.backgroundImage = 'url(' + image + ')';
        }

        function handleDotEvent(e) {
            if (e.type === 'before.lory.init') {
                for (let i = 0, len = dotCount; i < len; i++) {
                    let clone = dotListItem.cloneNode();
                    dotContainer.appendChild(clone);
                }
                dotContainer.childNodes[0].classList.add('active');
            }
            if (e.type === 'after.lory.init') {
                for (let i = 0, len = dotCount; i < len; i++) {
                    dotContainer.childNodes[i].addEventListener('click', function (e) {
                        dotNavigationSlider.slideTo(Array.prototype.indexOf.call(dotContainer.childNodes, e.target));
                    });
                }
            }
            if (e.type === 'after.lory.slide') {
                for (let i = 0, len = dotContainer.childNodes.length; i < len; i++) {
                    dotContainer.childNodes[i].classList.remove('active');
                }
                dotContainer.childNodes[e.detail.currentSlide - 1].classList.add('active');
            }
            if (e.type === 'on.lory.resize') {
                for (let i = 0, len = dotContainer.childNodes.length; i < len; i++) {
                    dotContainer.childNodes[i].classList.remove('active');
                }
                dotContainer.childNodes[0].classList.add('active');
            }
        }

        slider.addEventListener('before.lory.init', handleDotEvent);
        slider.addEventListener('after.lory.init', handleDotEvent);
        slider.addEventListener('after.lory.slide', handleDotEvent);
        slider.addEventListener('on.lory.resize', handleDotEvent);

        const dotNavigationSlider = lory(slider, {
            infinite: 1,
            enableMouseEvents: true
        });
    }
};
